import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonFormattingModule, CommonTranslationModule } from '@sdbn/common';
import { TransportListComponent } from './component/transport-list.component';
import { TmcYardCommonModule } from '../../../common/common.module';
import { TransportColumnFormatPipe } from './column-format.pipe';

import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';


@NgModule({
  declarations: [
    TransportListComponent,
    TransportColumnFormatPipe
  ],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    CommonFormattingModule,
    MatTableModule,
    MatSortModule
  ],
  exports: [
    TransportListComponent
  ]
})
export class TransportListModule { }
